export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  novoTipo: {
    pt: 'Novo Tipo',
    en: 'New Type',
    de: 'Nuevo tipo',
    es: 'Nuevo tipo',
  },
  novoTiporessalva: {
    pt: 'Novo Tipo de Ressalve',
    en: 'New Caveat Type',
    de: 'Neuer Einspruchstyp',
    es: 'Nuevo tipo de ressalva',
  },
  voltar: {
    pt: 'Voltar',
    en: 'Go back',
    de: 'Geh zurück',
    es: 'Regresa',
  },
};